import React from "react";
import "./Navbarstart.css";

import Logo from "../assets/fullLogoWide.webp"; //  src/images
import { NavLink } from "react-router-dom";

function Navbar() {
  return (
    <nav className="navbar">
        
      <div className="container">
      <a className="navbar-brand" href="https://www.theclassplan.com/" target="_blank" rel="noopener noreferrer">
          <img src={Logo} alt="" height="55"></img>
        </a>
        {/* <h6 className = "title">THE CLASS PLAN</h6> */}
      </div>
    </nav>

    
  );
}
export default Navbar;
